import { useEffect, useState } from "react";
import { Check, Inbox, X } from "lucide-react";
import { Empty, StatusPill } from "../../components/common";
import { api, dateTime, errMsg, idr } from "../../lib/api";

export default function AdminWithdrawals() {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState([]);
  const [tick, setTick] = useState(0);
  const [notes, setNotes] = useState({});
  const [msg, setMsg] = useState("");
  useEffect(() => {
    let alive = true;
    api.get("/admin/withdrawals", { params: status ? { status } : {} }).then((r) => alive && setRows(r.data));
    return () => { alive = false; };
  }, [status, tick]);

  const review = async (w, action) => {
    if (action === "paid" && !window.confirm(`Konfirmasi sudah transfer ${idr(w.amount)} ke ${w.provider} ${w.account_number}?`)) return;
    try {
      await api.post(`/admin/withdrawals/${w.id}/review`, { action, note: notes[w.id] || "" });
      setMsg(action === "paid" ? "Penarikan ditandai dibayar." : "Penarikan ditolak.");
      setTick((t) => t + 1);
    } catch (err) {
      setMsg(errMsg(err, "Gagal memproses penarikan"));
    }
  };

  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">ADMIN · AFFILIATE PAYOUT</p><h2>Penarikan komisi</h2><p className="muted">Transfer manual ke rekening/e-wallet member, lalu tandai dibayar. Member menerima notifikasi email & WhatsApp.</p></div>
      </div>
      <div className="seg tabs">
        {[["pending", "Menunggu"], ["paid", "Dibayar"], ["rejected", "Ditolak"], ["", "Semua"]].map(([v, l]) => (
          <button key={v || "all"} className={status === v ? "active" : ""} onClick={() => setStatus(v)} data-testid={`admin-wd-filter-${v || "all"}`}>{l}</button>
        ))}
      </div>
      {msg && <div className="notice info" data-testid="admin-wd-message">{msg}</div>}
      <section className="panel table-panel">
        {rows.length === 0 ? <Empty testId="admin-wd-empty" icon={Inbox} title="Tidak ada penarikan" text="Belum ada permintaan pada filter ini." /> : (
          <>
            <div className="table-row cols-5 table-head"><span>TANGGAL</span><span>MEMBER</span><span>TUJUAN</span><span>NOMINAL</span><span>AKSI</span></div>
            {rows.map((w) => (
              <div className="table-row cols-5" key={w.id} data-testid={`admin-wd-row-${w.id}`}>
                <span>{dateTime(w.created_at)}</span>
                <span>{w.member?.name}<small className="muted block">{w.member?.phone}</small></span>
                <span>{w.provider} · {w.account_number}<small className="muted block">a.n. {w.account_name}</small></span>
                <span>{idr(w.amount)}</span>
                {w.status === "pending" ? (
                  <span className="row-end">
                    <input className="inline-input" placeholder="Catatan" value={notes[w.id] || ""} onChange={(e) => setNotes({ ...notes, [w.id]: e.target.value })} data-testid={`admin-wd-note-${w.id}`} />
                    <button className="danger sm" onClick={() => review(w, "reject")} data-testid={`admin-wd-reject-${w.id}`}><X size={13} /></button>
                    <button className="primary sm" onClick={() => review(w, "paid")} data-testid={`admin-wd-paid-${w.id}`}><Check size={13} /> Dibayar</button>
                  </span>
                ) : <span className="row-end"><StatusPill status={w.status} />{w.review_note && <small className="muted">{w.review_note}</small>}</span>}
              </div>
            ))}
          </>
        )}
      </section>
    </>
  );
}
